module.exports = __webpack_public_path__ + "static/media/AMZNP.0083a3b2.svg";